import AccessTokenResourceModel from '../../generated/types/model/resource/AccessTokenResourceModel';

export default class AccessTokenResourceViewModel extends AccessTokenResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
